import React, { Component } from 'react';
import { func, bool, arrayOf, string } from 'prop-types';
import { connect } from 'react-redux';

import AuthActions from '~redux/Auth/actions';
import ModalActions from '~redux/Modal/actions';
import CartActions from '~redux/Cart/actions';
import SearchStoreActions from '~redux/SearchStore/actions';
import { TARGETS } from '~redux/Auth/constants';
import { ALL_STORES, NEAR_TARGET } from '~redux/SearchStore/constants';
import { MODALS } from '~redux/Modal/constants';
import {
  USER_ADRESSES,
  CURRENT_SUBSIDIARY_TARGET,
  DISPATCH_METHOD_TARGET
} from '~redux/SearchStore/constants';
import { addressPropTypes } from '~propTypes/address';
import shapeStore from '~constants/propTypes';
import { DISPATCH_METHODS } from '~constants/address';
import NextUpActions from '~redux/NextUp/actions';

import ChangeAddress from './layout';

class ChangeAddressModal extends Component {
  state = {
    missingItems: [],
    selectedAddress: this.props.currentAddress,
    selectedDispatchMethod: this.props.currentDispatchMethod,
    selectedStore: null,
    addressReady: false
  };

  handleAddressSelect = ({ addressData, onlyPickup = false }) => {
    this.setState({
      selectedAddress: addressData,
      selectedDispatchMethod: DISPATCH_METHODS.DELIVERY,
      ...(!onlyPickup && { addressReady: true })
    });
  };

  handleAddressConfirm = ({ store, addressDetails, type }) => {
    const { selectedAddress } = this.state;
    const address = { ...selectedAddress, ...addressDetails };

    this.setState(
      {
        selectedAddress: address,
        selectedDispatchMethod: type,
        selectedStore: store
      },
      () => {
        this.handleStoreChange();
      }
    );
  };

  handleCartItemsRemoval = () => this.handleStoreChange(true);

  handleStoreChange = () => {
    const { selectedAddress, selectedStore, selectedDispatchMethod } = this.state;
    const { closeChangeAddressModal, setAddress, setStore, checkCart } = this.props;
    setStore(selectedStore.id, selectedDispatchMethod)
      .then(() => setAddress(selectedAddress))
      .then(checkCart);
    closeChangeAddressModal();
    this.setState({ selectedStore: null });
  };

  handleSearchInputChange = () => {
    this.setState({
      selectedAddress: null,
      addressReady: null,
      selectedStore: null
    });
  };

  handleStoreSelect = ({ store }) => {
    this.setState({
      selectedStore: store,
      selectedDispatchMethod: DISPATCH_METHODS.PICKUP
    });
  };

  changeDeliveryMethod = () => {
    const { addressReady, selectedAddress } = this.state;
    const { currentDispatchMethod } = this.props;

    if (!addressReady) {
      this.setState({
        selectedDispatchMethod: DISPATCH_METHODS.DELIVERY,
        selectedAddress: currentDispatchMethod === DISPATCH_METHODS.DELIVERY ? selectedAddress : {},
        selectedStore: null
      });
    }
  };

  handleClose = () => {
    const { addressReady, selectedAddress } = this.state;
    const { currentDispatchMethod, clearNextActions, currentAddress } = this.props;

    clearNextActions(!!currentAddress);

    this.setState({
      selectedDispatchMethod: currentDispatchMethod,
      selectedStore: null,
      selectedAddress:
        addressReady || currentDispatchMethod === DISPATCH_METHODS.DELIVERY ? selectedAddress : {}
    });
  };

  render() {
    const {
      loading,
      lastAddresses,
      isGuestUser,
      smartBannerValue,
      isDefaultStore,
      isOpen,
      hideCloseButton,
      storeChanged = false,
      stores,
      storesError
    } = this.props;
    const { selectedAddress, missingItems, addressReady, selectedDispatchMethod, selectedStore } = this.state;
    return (
      <ChangeAddress
        loading={loading}
        isOpen={isOpen}
        isGuestUser={isGuestUser}
        lastAddresses={lastAddresses}
        selectedAddress={selectedAddress}
        missingItems={missingItems}
        onInit={this.handleInit}
        onConfirm={this.handleAddressConfirm}
        onAddressSelect={this.handleAddressSelect}
        onSearchInputChange={this.handleSearchInputChange}
        smartBannerValue={smartBannerValue}
        isDefaultStore={isDefaultStore}
        isAddressReady={addressReady}
        hideCloseButton={hideCloseButton}
        storeChanged={storeChanged}
        stores={stores}
        storesError={storesError}
        onStoreSelect={this.handleStoreSelect}
        selectedDispatchMethod={selectedDispatchMethod}
        changeDeliveryMethod={this.changeDeliveryMethod}
        selectedStore={selectedStore}
        onClose={this.handleClose}
      />
    );
  }
}

ChangeAddressModal.propTypes = {
  checkCart: func.isRequired,
  clearNextActions: func.isRequired,
  closeChangeAddressModal: func.isRequired,
  setAddress: func.isRequired,
  setStore: func.isRequired,
  currentAddress: addressPropTypes,
  currentDispatchMethod: string,
  hideCloseButton: bool,
  isDefaultStore: bool,
  isGuestUser: bool,
  isOpen: bool,
  lastAddresses: arrayOf(addressPropTypes),
  loading: bool,
  smartBannerValue: bool,
  storeChanged: bool,
  stores: arrayOf(shapeStore),
  storesError: string
};

const mapStateToProps = (state) => ({
  loading: state.searchStore[`${USER_ADRESSES}Loading`],
  isGuestUser: !state.auth[TARGETS.CURRENT_USER],
  currentDispatchMethod: state.searchStore[DISPATCH_METHOD_TARGET],
  currentStore: state.searchStore[CURRENT_SUBSIDIARY_TARGET],
  currentAddress: state.auth[TARGETS.ADDRESS]?.current,
  isLoggedIn: true,
  lastAddresses: state.auth[TARGETS.ADDRESS]?.history,
  isOpen: state.modal[`${MODALS.DELIVERY_OR_PICKUP}ModalIsOpen`],
  storeChanged: state.modal[`${MODALS.DELIVERY_OR_PICKUP}`]?.data.storeChanged,
  stores: state.searchStore[ALL_STORES],
  storesError: state.searchStore[`${NEAR_TARGET}Error`]
});

const mapDispatchToProps = (dispatch) => ({
  closeChangeAddressModal: () => {
    dispatch(ModalActions.closeModal(MODALS.DELIVERY_OR_PICKUP));
  },
  clearNextActions: (hasCurrentAddress) => {
    if (!hasCurrentAddress) {
      dispatch(
        NextUpActions.clearAllActionsByTarget(
          ModalActions.openModalWithData(MODALS.DELIVERY_OR_PICKUP).target
        )
      );
    }
  },
  setValue: (target, payload) => dispatch(SearchStoreActions.setValue(target, payload)),
  setAddress: (address) => dispatch(AuthActions.setAddress(address)),
  setStore: (idSubsidiary, dispatchType, currentSubsidiary = null) =>
    dispatch(SearchStoreActions.getStoreData(idSubsidiary, dispatchType, currentSubsidiary)),
  checkCart: () => dispatch(CartActions.checkCart())
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAddressModal);
